import _toConsumableArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useRouter } from 'next/router';
import { useState, useMemo } from 'react';
import { AlertDot } from '@yoweb/ui/components/indicators';
import { Box } from '@yoweb/ui/components/Box';
import { Title, Text, Interactive } from '@yoweb/ui/components/typography';
import { useTranslation } from '@yoweb/next-i18next';
import Spinner from '@yoweb/ui/components/Spinner';
import { TaskActionCard } from '@poplar/components/Home/TaskActionCard';
import { Tabs, Tab } from '@yoweb/ui/components/Tabs';
import { QUERY_TASK_TAB_ID } from '@poplar/constants/queryParams';
import { EmptySection, GetStarted } from './TodosPageCommon';
import { CaretDownThickIcon, CaretUpIcon } from '@yoweb/ui/components/Icon';
import { convertTimeProtoToTimestamp } from '@yoweb/utils/converters';
import { useEntitlement } from '@poplar/contexts/EntitlementProvider';
import { AccessType } from '@poplar/types/enums';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var TodoStateTabTypes;

(function (TodoStateTabTypes) {
  TodoStateTabTypes["drafts"] = "drafts";
  TodoStateTabTypes["upcoming"] = "upcoming";
  TodoStateTabTypes["archived"] = "archived";
  TodoStateTabTypes["inProgress"] = "inProgress";
})(TodoStateTabTypes || (TodoStateTabTypes = {}));

var getActiveTabId = function getActiveTabId(router) {
  if (typeof router.query[QUERY_TASK_TAB_ID] === 'string') {
    return router.query[QUERY_TASK_TAB_ID];
  } // when no query param set, default to inProgress


  return TodoStateTabTypes.inProgress;
};

var triggerTabUpdate = function triggerTabUpdate(router, tab) {
  return void router.replace({
    pathname: router.pathname,
    query: _objectSpread(_objectSpread({}, router.query), {}, _defineProperty({}, QUERY_TASK_TAB_ID, tab))
  }, undefined, {
    shallow: true
  });
};

var TodosPageSmall = function TodosPageSmall(_ref) {
  var dataCompleted = _ref.dataCompleted,
      dataInProgress = _ref.dataInProgress,
      dataDraft = _ref.dataDraft,
      dataUpcoming = _ref.dataUpcoming,
      showGettingStarted = _ref.showGettingStarted,
      isDeletingBookmark = _ref.isDeletingBookmark,
      sectionIndicators = _ref.sectionIndicators,
      openFeedbackFlyout = _ref.openFeedbackFlyout,
      onDeleteExpiredBookmark = _ref.onDeleteExpiredBookmark;

  var _useTranslation = useTranslation('tasks'),
      t = _useTranslation.t;

  var router = useRouter();

  var _useEntitlement = useEntitlement(),
      accessType = _useEntitlement.accessType;

  var activeTabId = getActiveTabId(router);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Title, {
      size: "lg",
      as: "h1",
      children: t('to-dos')
    }), /*#__PURE__*/_jsx(Box, {
      mt: "normal1",
      children: /*#__PURE__*/_jsxs(Tabs, {
        blendColor: "sandLight",
        activeTabId: activeTabId,
        onChange: function onChange(tabLabel) {
          void triggerTabUpdate(router, tabLabel);
        },
        children: [/*#__PURE__*/_jsx(Tab, {
          id: TodoStateTabTypes.drafts,
          label: /*#__PURE__*/_jsx(LabelWithIndicator, {
            text: t('to-do-states.draft'),
            hasIndicator: sectionIndicators.draft
          }),
          children: /*#__PURE__*/_jsx(Box, {
            mt: "normal1",
            "data-testid": "task-section-drafts-small",
            children: /*#__PURE__*/_jsx(TodosList, {
              tasksData: dataDraft,
              isDeletingBookmark: isDeletingBookmark,
              openFeedbackFlyout: openFeedbackFlyout,
              onDeleteExpiredBookmark: onDeleteExpiredBookmark,
              EmptySectionElement: /*#__PURE__*/_jsx(EmptySectionSmall, {
                testId: "drafts-empty",
                title: t('to-dos-page.drafts-empty.title'),
                text: t('to-dos-page.drafts-empty.text')
              })
            })
          })
        }), /*#__PURE__*/_jsx(Tab, {
          id: TodoStateTabTypes.upcoming,
          label: /*#__PURE__*/_jsx(LabelWithIndicator, {
            text: t('to-do-states.upcoming'),
            hasIndicator: sectionIndicators.upcoming
          }),
          children: /*#__PURE__*/_jsx(Box, {
            mt: "normal1",
            "data-testid": "task-section-upcoming-small",
            children: showGettingStarted ? /*#__PURE__*/_jsx(GetStarted, {}) : /*#__PURE__*/_jsx(TodosList, {
              tasksData: dataUpcoming,
              isDeletingBookmark: isDeletingBookmark,
              openFeedbackFlyout: openFeedbackFlyout,
              onDeleteExpiredBookmark: onDeleteExpiredBookmark,
              EmptySectionElement: /*#__PURE__*/_jsx(EmptySectionSmall, {
                testId: "upcoming-empty",
                title: t('to-dos-page.upcoming-empty.title'),
                text: t('to-dos-page.upcoming-empty.text')
              })
            })
          })
        }), /*#__PURE__*/_jsx(Tab, {
          id: TodoStateTabTypes.inProgress,
          label: /*#__PURE__*/_jsx(LabelWithIndicator, {
            text: t('to-do-states.in-progress'),
            hasIndicator: sectionIndicators.inProgress
          }),
          children: /*#__PURE__*/_jsx(Box, {
            mt: "normal1",
            "data-testid": "task-section-in-progress-small",
            children: showGettingStarted ? /*#__PURE__*/_jsx(GetStarted, {}) : /*#__PURE__*/_jsx(TodosList, {
              tasksData: dataInProgress,
              isDeletingBookmark: isDeletingBookmark,
              openFeedbackFlyout: openFeedbackFlyout,
              onDeleteExpiredBookmark: onDeleteExpiredBookmark,
              EmptySectionElement: /*#__PURE__*/_jsx(EmptySectionSmall, {
                testId: "in-progress-empty",
                title: t('to-dos-page.in-progress-empty.title'),
                text: t('to-dos-page.in-progress-empty.text')
              })
            })
          })
        }), accessType !== AccessType.PREVIEW && /*#__PURE__*/_jsx(Tab, {
          id: TodoStateTabTypes.archived,
          label: /*#__PURE__*/_jsx(LabelWithIndicator, {
            text: t('to-do-states.archived'),
            hasIndicator: sectionIndicators.completed
          }),
          children: /*#__PURE__*/_jsx(Box, {
            mt: "normal1",
            "data-testid": "task-section-archived-small",
            children: /*#__PURE__*/_jsx(TodosList, {
              tasksData: dataCompleted,
              isDeletingBookmark: isDeletingBookmark,
              openFeedbackFlyout: openFeedbackFlyout,
              onDeleteExpiredBookmark: onDeleteExpiredBookmark,
              EmptySectionElement: /*#__PURE__*/_jsx(EmptySectionSmall, {
                testId: "archived-empty",
                title: t('to-dos-page.completed-empty.title'),
                text: t('to-dos-page.completed-empty.text')
              })
            })
          })
        })]
      })
    })]
  });
};

var LabelWithIndicator = function LabelWithIndicator(_ref2) {
  var text = _ref2.text,
      hasIndicator = _ref2.hasIndicator;
  return /*#__PURE__*/_jsxs(Box, {
    display: "flex",
    gap: "small2",
    alignItems: "center",
    children: [hasIndicator && /*#__PURE__*/_jsx(AlertDot, {
      color: "critical"
    }), text]
  });
};

var PAGE_SIZE = 15;
var TASK_COUNT_INITIAL = 15;

var TodosList = function TodosList(_ref3) {
  var tasksData = _ref3.tasksData,
      EmptySectionElement = _ref3.EmptySectionElement,
      isDeletingBookmark = _ref3.isDeletingBookmark,
      onDeleteExpiredBookmark = _ref3.onDeleteExpiredBookmark,
      openFeedbackFlyout = _ref3.openFeedbackFlyout;

  var _useState = useState(TASK_COUNT_INITIAL),
      showingCount = _useState[0],
      setShowingCount = _useState[1];

  var _useTranslation2 = useTranslation('tasks'),
      t = _useTranslation2.t;

  var tasksAllLoaded = useMemo(function () {
    var _tasksData$data;

    var tasksAll = tasksData === null || tasksData === void 0 ? void 0 : (_tasksData$data = tasksData.data) === null || _tasksData$data === void 0 ? void 0 : _tasksData$data.reduce(function (acc, curr) {
      if (curr !== null && curr !== void 0 && curr.tasks) {
        return [].concat(_toConsumableArray(acc), _toConsumableArray(curr.tasks));
      }

      return acc;
    }, []);

    if (tasksAll) {
      return tasksAll;
    }

    return [];
  }, [tasksData]);
  var tasks = useMemo(function () {
    if (tasksAllLoaded) {
      return tasksAllLoaded.slice(0, showingCount);
    }

    return [];
  }, [tasksAllLoaded, showingCount]);
  var nextPageToken = useMemo(function () {
    var _tasksData$data2;

    if (!(tasksData !== null && tasksData !== void 0 && tasksData.data)) return null;
    return (_tasksData$data2 = tasksData.data[tasksData.data.length - 1]) === null || _tasksData$data2 === void 0 ? void 0 : _tasksData$data2.encodedNextPageToken;
  }, [tasksData === null || tasksData === void 0 ? void 0 : tasksData.data]);
  if (!(tasksData !== null && tasksData !== void 0 && tasksData.data)) return null;
  var hasShowLess = !nextPageToken && tasks.length > TASK_COUNT_INITIAL && showingCount >= tasksAllLoaded.length;
  var hasShowMore = tasksAllLoaded.length > showingCount || nextPageToken;

  var viewMore = function viewMore() {
    if (tasksData.isValidating) {
      return;
    }

    if (tasks.length > showingCount) {
      if (showingCount + PAGE_SIZE > tasks.length) {
        setShowingCount(tasks.length);
      } else {
        setShowingCount(showingCount + PAGE_SIZE);
      }
    } else {
      setShowingCount(showingCount + PAGE_SIZE);

      if (nextPageToken) {
        void tasksData.setSize(tasksData.size + 1);
      }
    }
  };

  var viewLess = function viewLess() {
    setShowingCount(TASK_COUNT_INITIAL);
  };

  if (tasks.length === 0) {
    return EmptySectionElement;
  }

  return /*#__PURE__*/_jsxs(Box, {
    display: "grid",
    gap: "small4",
    children: [tasks.map(function (task) {
      return /*#__PURE__*/_jsx(TaskActionCard, {
        task: task,
        isDeletingBookmark: isDeletingBookmark,
        onDeleteExpiredBookmark: function (_onDeleteExpiredBookmark) {
          function onDeleteExpiredBookmark() {
            return _onDeleteExpiredBookmark.apply(this, arguments);
          }

          onDeleteExpiredBookmark.toString = function () {
            return _onDeleteExpiredBookmark.toString();
          };

          return onDeleteExpiredBookmark;
        }(function () {
          return onDeleteExpiredBookmark(task);
        }),
        onFeedbackRating: function onFeedbackRating(rating) {
          openFeedbackFlyout === null || openFeedbackFlyout === void 0 ? void 0 : openFeedbackFlyout({
            taskId: task.taskId,
            name: task.name,
            updated: convertTimeProtoToTimestamp(task.updatedTimestamp),
            taskIsRepeatable: task.isRepeatable,
            taskIsRepeating: task.isRepeating
          }, rating);
        }
      }, task.taskId);
    }), hasShowMore && /*#__PURE__*/_jsx(Box, {
      onClick: viewMore,
      "data-testid": "view-more-button",
      children: /*#__PURE__*/_jsx(Box, {
        display: "flex",
        gap: "small3",
        alignItems: "center",
        justifyContent: "center",
        p: "small3",
        children: tasksData.isValidating ? /*#__PURE__*/_jsx(Spinner, {
          size: "md"
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Interactive, {
            size: "md",
            children: t('to-dos-page.view-more')
          }), ' ', /*#__PURE__*/_jsx(CaretDownThickIcon, {})]
        })
      })
    }), hasShowLess && /*#__PURE__*/_jsx(Box, {
      onClick: viewLess,
      "data-testid": "view-less-button",
      children: /*#__PURE__*/_jsxs(Box, {
        display: "flex",
        gap: "small3",
        alignItems: "center",
        justifyContent: "center",
        p: "small3",
        children: [/*#__PURE__*/_jsx(Interactive, {
          size: "md",
          children: t('to-dos-page.view-less')
        }), " ", /*#__PURE__*/_jsx(CaretUpIcon, {})]
      })
    })]
  });
};

var EmptySectionSmall = function EmptySectionSmall(_ref4) {
  var testId = _ref4.testId,
      title = _ref4.title,
      text = _ref4.text;
  return /*#__PURE__*/_jsxs(EmptySection, {
    "data-testid": testId,
    children: [/*#__PURE__*/_jsx(Title, {
      size: "sm",
      textAlign: "center",
      children: title
    }), /*#__PURE__*/_jsx(Box, {
      mt: "small3",
      children: /*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        children: text
      })
    })]
  });
};

export { TodosPageSmall };